import { WithAdvertising } from './WithAdvertising';

export { WithAdvertising };
export default WithAdvertising;
